import React from 'react';
import {   Table, Icon, List, Popup } from 'semantic-ui-react';
import { Link } from "react-router-dom";


const CursoAprendizajeRow=({cursoaprendizaje, onShowModalBorrar, onShowModalActivar, color,form, permisos})=>{
    return (
    <Table.Row>
                        <Table.Cell>{cursoaprendizaje.descripcion}</Table.Cell>
                        <Table.Cell textAlign="center">{cursoaprendizaje.estatus}</Table.Cell>
                        <Table.Cell textAlign="center">
                            <List horizontal>
                                <List.Item>
                                    <Link to={"/cursoaprendizaje/"+cursoaprendizaje.id}> 
                                     <Popup
                                        trigger={<Icon  name='edit outline' link   size="large"  color="tela" ></Icon>}
                                        content='Editar'
                                       
                                      />
                                     </Link> 
                                    
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name='trash alternate outline' link 
                                            onClick={()=>onShowModalBorrar(cursoaprendizaje.id)} 
                                            size="large" color="red"  />
                                        }
                                        content='Borrar'
                                      />
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name={cursoaprendizaje.idEstatus==1?'x':'check'} link  size="large" 
                                                color={cursoaprendizaje.idEstatus==1?"orange":"green"}  
                                                onClick={()=>onShowModalActivar(cursoaprendizaje.id)} 
                                            />
                                        }
                                        content={cursoaprendizaje.idEstatus==1?'Inactivar':'Activar'}
                                      />  
                                    
                                </List.Item>
                            </List>
                    </Table.Cell>
                      
        </Table.Row>
    
    )
}


export default CursoAprendizajeRow;